import { useTranslation } from 'react-i18next';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import './Container.less';
import Header from '../components/HeaderForPC';
import Footer from '../components/FooterForPC';
import BaseContainer from '../components/BaseContainer';
import { getTime } from '~/utils/getTime';
import { customRedirect } from '~/utils/link/goPage';
import { newTabName, TAB_NAME_TYPE } from '~/utils/newsTab';
import { getSpecFont } from '~/utils/fontClass/index';
import useAreaLimit from '~/common/hooks/useAreaLimit';
import DomainLimit from '~/components/domainLimit';
import { getNews, getTOPNews } from '../common/services/siteData';

export default function Container() {
  const { t, i18n } = useTranslation();

  const { isLimit } = useAreaLimit();
  const [newsLength, setNewsLength] = useState(0);
  const [topData, setTopData] = useState([]);

  const [tabs, setTabs] = useState(newTabName);
  const [news, setNews] = useState([]);
  const [more, setMore] = useState(false);
  const [type, setType] = useState(TAB_NAME_TYPE[0]);
  const page = useRef(1);
  const size = useRef(10);
  const lock = useRef(false);

  const goDetail = useCallback((item) => {
    if (!item.url) {
      customRedirect(`./newsdetail?id=${item.id}`);
    } else {
      window.open(item.url);
    }
  }, []);

  // 点击切换tab
  const handleSelectTab = (index) => {
    if (tabs[index].active) {
      return;
    }
    if (lock.current) {
      return;
    }
    let targetType = TAB_NAME_TYPE[index];
    setTabs((tbs) => {
      tbs.forEach((i) => (i.active = false));
      tbs[index].active = true;
      return [...tbs];
    });
    setType(targetType);
    page.current = 0;
    // 获取数据
    loadMoreNews(targetType, false);
  };

  // 点击加载更多
  const loadMoreNews = async (targetType, isAppend = true) => {
    if (lock.current) {
      return;
    }
    lock.current = true;
    const res = await getNews({
      type: targetType,
      page: page.current + 1,
      size: size.current,
      language: i18n.language
    });
    if (isAppend) {
      setNews((old) => {
        return old.concat(res.data);
      });
    } else {
      setNews(res.data);
    }
    if (res.pageIndex * res.pageSize >= res.totalCount) {
      setMore(false);
    } else {
      setMore(true);
    }
    page.current += 1;
    lock.current = false;
  };

  // 获取ALL新闻
  useEffect(() => {
    // 获取默认
    let count = 0;
    console.log('i18n.language', i18n.language);
    const init = () => {
      if (lock.current) {
        return;
      }
      lock.current = true;
      page.current = 1;
      size.current = 10;
      getList();
      getTop();
    };
    const done = () => {
      count += 1;
      if (count >= 2) {
        lock.current = false;
      }
    };
    const getList = async () => {
      const res = await getNews({
        type: type,
        page: page.current,
        size: size.current,
        language: i18n.language
      });
      setNews(res.data);
      if (res.pageIndex * res.pageSize >= res.totalCount) {
        setMore(false);
      } else {
        setMore(true);
      }
      done();
    };
    // 获取置顶
    const getTop = async () => {
      const res = await getTOPNews(i18n.language);
      let data = res.data.slice(0, 3);
      setTopData(data);
      setNewsLength(data.length);
      done();
    };

    init();
  }, [t]);

  if (isLimit) {
    return <DomainLimit />;
  }

  return (
    <BaseContainer>
      <Header />
      <div styleName="news_list_banner">
        <TopNews data={topData} length={newsLength} goDetail={goDetail} i18n={i18n} />
      </div>
      <div styleName="news_list_contain">
        <div styleName="news_tab_title">
          {tabs.map((item, index) => {
            return (
              <div
                styleName={item.active ? 'tab_list tab_act' : 'tab_list'}
                key={index}
                className={getSpecFont(i18n.language, false)}
                onClick={() => handleSelectTab(index)}
              >
                {t(item.key)}
              </div>
            );
          })}
        </div>
        {/* 选项卡内容区 */}
        <div styleName="tab_change_contain">
          {news.map((item) => (
            <div styleName="newList_wrap" key={item.id} onClick={() => goDetail(item)}>
              <div styleName="newsList_left">
                <img src={item?.image} alt="" />
              </div>
              <div styleName="newsList_center">
                <div styleName="tab_active_name" className={getSpecFont(i18n.language, false)}>
                  {item?.description}
                </div>
                <div styleName="tab_active_title" className={getSpecFont(i18n.language, false)}>
                  {item?.title}
                </div>
                <div styleName="tab_active_date" className={getSpecFont(i18n.language, false)}>
                  {getTime(item?.update_at * 1000, 'MM/dd/yyyy')}
                </div>
              </div>
              <div styleName="newsList_right">
                <div styleName="jiantou"></div>
              </div>
            </div>
          ))}
        </div>
        {more && (
          <div styleName="btn_load_more" onClick={() => loadMoreNews(type)}>
            {t('load_more')}
          </div>
        )}
      </div>
      <Footer customStyle={{}} />
    </BaseContainer>
  );
}

const TopNews = ({ data, length, goDetail, i18n }) => {
  if (length === 0) {
    return <></>;
  }
  if (length === 1) {
    return <SingleTopNews item={data[0]} goDetail={goDetail} i18n={i18n} />;
  } else if (length === 2) {
    return <DoubleTopNews data={data} goDetail={goDetail} i18n={i18n} />;
  } else {
    return <MulityTopNews data={data} goDetail={goDetail} i18n={i18n} />;
  }
};

const SingleTopNews = ({ item, goDetail, i18n }) => {
  return (
    <div styleName="home_news_01_wrap" onClick={() => goDetail(item)}>
      <div styleName="home_01_bg">
        <div styleName="incline_block_01"></div>
        <img src={item?.image} alt="" />
      </div>
      <div styleName="home_01_right">
        <div styleName="home_01_title" className={getSpecFont(i18n.language, false)}>
          {item?.description}
        </div>
        <div styleName="home_01_desc" className={getSpecFont(i18n.language, false)}>
          {item?.title}
        </div>
        <div styleName="home_01_date" className={getSpecFont(i18n.language, false)}>
          {getTime(item?.update_at * 1000, 'MM/dd/yyyy')}
        </div>
        <div styleName="home_01_arrow"></div>
      </div>
    </div>
  );
};

const DoubleTopNews = ({ data, goDetail, i18n }) => {
  return (
    <div styleName="home_news_wrap_2">
      {data.map((item, index) => {
        return (
          <div key={index} styleName="home_newss_2" onClick={() => goDetail(item)}>
            <div styleName="home_news_bg_2">
              <div styleName="incline_block_02"></div>
              <img src={item?.image} alt="" />
            </div>
            <div styleName="home_news_title_2" className={getSpecFont(i18n.language, false)}>
              {item?.description}
            </div>
            <div styleName="home_news_desc_2" className={getSpecFont(i18n.language, false)}>
              {item?.title}
            </div>
            <div styleName="home_news_date_2" className={getSpecFont(i18n.language, false)}>
              {getTime(item?.update_at * 1000, 'MM/dd/yyyy')}
            </div>
          </div>
        );
      })}
    </div>
  );
};

const MulityTopNews = ({ data, goDetail, i18n }) => {
  return (
    <div styleName="home_news_wrap">
      {data.map((item, index) => {
        return (
          <div key={index} styleName="home_news" onClick={() => goDetail(item)}>
            <div styleName="home_news_bg">
              <div styleName="incline_block_02"></div>
              <img src={item?.image} alt="" />
            </div>
            <div styleName="white_bg">
              <div styleName="home_news_title" className={getSpecFont(i18n.language, false)}>
                {item?.description}
              </div>
              <div styleName="home_news_desc" className={getSpecFont(i18n.language, false)}>
                {item?.title}
              </div>
              <div styleName="home_news_date" className={getSpecFont(i18n.language, false)}>
                {getTime(item?.update_at * 1000, 'MM/dd/yyyy')}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};
